import axios from 'axios'

export const addUrlChange = (tracking, path) => async (dispatch, getState, { metrics }) => {
  try {
    if (tracking) {
      const res = await axios.get('https://geolocation-db.com/json/')
      await metrics.addUrlChange({ location: res.data, path })
    } else {
      await metrics.addUrlChange({ path })
    }
  } catch (error) {
    console.error(error)
  }
}
